import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { BsApiService } from '@brightside-web/desktop/data-access/core-services';
import * as ServiceInventoryActions from './service-inventory.actions';
import { catchError, exhaustMap, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ServiceInventoryPayload } from './service-inventory.model';
import { loadServiceInventoryFailure } from './service-inventory.actions';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ServiceInventoryEffects {
  constructor(private actions$: Actions, private bsApi: BsApiService) {}

  loadServiceInventory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ServiceInventoryActions.loadServiceInventory),
      exhaustMap(() =>
        this.bsApi.get<ServiceInventoryPayload>('api-mobile', '/service-inventory').pipe(
          map((response) => {
            if (!response.payload.items || response.payload.items.length === 0) {
              return loadServiceInventoryFailure({ error: 'No services available' });
            }
            return ServiceInventoryActions.loadServiceInventorySuccess({ items: response.payload.items });
          }),
          catchError((error) => of(ServiceInventoryActions.loadServiceInventoryFailure({ error })))
        )
      )
    )
  );


  deleteServiceInventory$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ServiceInventoryActions.deleteServiceState),
        mergeMap((action) => this.bsApi.del('api-mobile', '/service-inventory', { key: action.key }))
      ),
    { dispatch: false }
  );
}
